import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Login } from 'react-cognito';
import theme from '../../../../assests/theme';
import { MuiButton, MuiTextField, MuiLockIcon, MuiPersonIcon, MuiTypography, MuiInputAdornment, muiWithStyles } from '../../../ui/MaterialUIComponents';
import routes from '../../../navigation/Routes'
import PageContainer from '../../../ui/PageContainer'
import MaterialUIForm from 'material-ui-form'
import { Typography, FormControl, Grid, TextField, Button, FormControlLabel } from '@material-ui/core'
import withAppShell from '../../../hoc/withAppShell/WithAppShell';
import LabeledCheckbox from '../../../ui/LabeledCheckbox'
import { connect } from 'react-redux'
import { getKeyFromLS } from '../../../../utils/LocalStorageUtil'
import lodashUtil from 'lodash'

export const User_Not_Found_Exception = "UserNotFoundException"
export const Not_Authorized_Exception = "NotAuthorizedException"
class SignInForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      email: props.email,
      username: props.username,
      password: '',
      rememberMe: false
    };

  }

  componentWillMount() {
    let i18n;
    if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
      i18n = getKeyFromLS("i18n");
    } else {
      i18n = this.props.i18n
    }
    this.setState({
      i18n: i18n
    })
  }

  validate = () => {

    var password = this.state.password
    if (password.length < 6) {
      this.setState({ error: "Password should have minimum 6 characters" })
      return false;
    }
    else {
      return true;
    }
  }

  manageErrorsFromCognitoForSignIn = (errorCode) => {
    const i18n = this.state.i18n
    switch (errorCode) {
      case User_Not_Found_Exception:
        return i18n.cognitoErrorMessages.UserNotFoundException_SignIn;
      case Not_Authorized_Exception:
        return i18n.cognitoErrorMessages.NotAuthorizedException_SignIn;
      default:
        break;
    }
  }

  onSubmit = () => {
    if (this.validate()) {
      localStorage.setItem('rememberMe', this.state.rememberMe);
      this.props.onSubmit(this.state.username, this.state.password)
        .then(() => this.setState({
          error: '',
        }),
          // toast code
        )
        .catch((err) => {
          let errorMessage = this.manageErrorsFromCognitoForSignIn(err.code)
          this.setState({
            error: errorMessage
          })
        });
    }
  }

  componentWillUnmount = () => {
    this.props.clearCache();
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      error: ''
    });
  };

  handleChangeCheckBox = name => event => {
    this.setState({
      [name]: event.target.checked,
      error: ''
    });
  };

  render() {
    return (

      <div style={theme.mainPageCardStyle}>
        <Typography variant={theme.typographyStyles.H4} style={theme.loginTitleStyle}>{this.state.i18n.signin.signInPageTitle}</Typography>
        <Typography variant='body2' color='primary' style={{ textAlign: 'center' }}>{this.state.i18n.signin.signInPageSubTitle}</Typography>
        <br />
        <MaterialUIForm onSubmit={this.onSubmit}>
          <MuiTextField
            id="username" label="Username" style={theme.muiTextFieldStyleForMainScreen}
            onChange={this.handleChange('username')} margin="normal" placeholder="Enter your Email" data-validators="isRequired,isEmail" type="email"
            required
            InputProps={{
              endAdornment: (
                <MuiInputAdornment position="end">
                  <MuiPersonIcon color='primary' />
                </MuiInputAdornment>
              ),
            }}
          />

          <br />

          <MuiTextField
            id="password" label="Password" style={theme.muiTextFieldStyleForMainScreen}
            onChange={this.handleChange('password')} margin="normal" placeholder="Enter your Password" type="password" data-validators="isRequired"
            required
            InputProps={{
              endAdornment: (
                <MuiInputAdornment position="end">
                  <MuiLockIcon color='primary' />
                </MuiInputAdornment>
              ),
            }}
          />

          <br />

          <MuiTypography variant="caption" color="error">{this.state.error}</MuiTypography>
          <MuiTypography variant="caption" style={{ color: theme.primaryColor }}>{this.state.email ? this.state.email + ' verified successfully,please login' : null}</MuiTypography>

          <br />


          <div style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
            {/* <MuiButton variant="flat"  style={theme.actionButton} type="submit">
        Login
      </MuiButton> */}
            {/* <FormControlLabel variant={theme.typographyStyles.CAPTION} color='primary' labelStyle={{ color:theme.primaryColor }}
      control={
        <Checkbox color='primary'
          checked={true ? true : false}
          //onChange={input.onChange}
        />
      }
      label="Remember me"
    /> */}
            <LabeledCheckbox
              checked={this.state.checkedB}
              onChange={this.handleChangeCheckBox("rememberMe")}
              checked={this.state.rememberMe}
              label={this.state.i18n.signin.rememberMe}
              variant={theme.typographyStyles.CAPTION}
            />
            <Link to={routes.reset} align="center" style={theme.linkStyle}>
              <MuiTypography variant={theme.typographyStyles.CAPTION} color='primary'>
              {this.state.i18n.signin.forgotPassword}
      </MuiTypography>
            </Link></div>

          <br />
          <div style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
            <Link to={routes.register} align="start" style={theme.linkStyle}>
              <MuiButton id="signUp" style={theme.secondaryButtonStyle} >{this.state.i18n.signup.signUpButton}</MuiButton>
            </Link>
            <Button id="signIn" style={theme.primaryButtonStyle} type="submit" >{this.state.i18n.signin.loginButton}</Button>
          </div>
          <br />
          {/* <div align='center' style={{ flexDirection: 'row', justify: 'center', width: '100%' }}>
            <div style={{ alignItems: 'center', width: '50%', align: 'right' }}><Link to={routes.reset} style={theme.linkStyle}>
              <MuiTypography variant={theme.typographyStyles.CAPTION} color='primary'>
                Terms of Use
      </MuiTypography>
            </Link>
            </div>
            <div style={{ alignItems: 'center', width: '50%', align: 'left' }} ><Link to={routes.reset} style={theme.linkStyle}>
              <MuiTypography variant={theme.typographyStyles.CAPTION} color='primary'>
                Privacy Policy
      </MuiTypography>
            </Link>
            </div>
          </div> */}
        </MaterialUIForm>
      </div>
    )
  }
}

SignInForm.propTypes = {
  onSubmit: PropTypes.func,
  clearCache: PropTypes.func,
  username: PropTypes.string,
  error: PropTypes.string,
  email: PropTypes.string,
};
const SignIn = () => (
  <PageContainer>
    <Login>
      <SignInForm />
    </Login>
  </PageContainer>
)


const componentStyle = (theme) => ({
  buttomdivStyle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    display: 'flex'
  },
});

const mapStateToProps = (state) => {
  return {
    i18n: state.i18nMessages.i18n
  }
}

export default withAppShell((muiWithStyles(componentStyle), connect(mapStateToProps)(SignIn)), { properties: { isProtected: false } });
